export type AlloyResponseDecision<TContent = object> = {
  id    : string,
  scope : string,
  items?: {
    data: {
      content: TContent
      format : string,
      id     : string
    },
    id  : string,
    meta: Partial<{
      'activity.name'  : string,
      'experience.name': string,
      [key: string]    : string
    }>,
    schema: string
  }[],
  scopeDetails: Partial<{
    activity: {
      id: string
    },
    characteristics: {
      analyticsToken?: string,
      eventToken     : string
    },
    correlationID   : string,
    decisionProvider: string,
    experience: {
      id: string
    },
    strategies: {
      step        : string,
      trafficType?: string,
      trafficTpye?: string
    }[]
  }>
};

export type AlloyResponsePropositions<TContent = object> = AlloyResponseDecision<TContent> & {
  renderAttempted?: boolean
}
